export type { GalleryProps } from "./gallery";
export { Gallery } from "./gallery";
